const cleanName = (name) => {
  return name
    .toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // remove acentos
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
};

const pathParts = window.location.pathname.split('/').filter(Boolean);
const countrySlug = pathParts[pathParts.length - 1];

const header = document.querySelector('header');
const menu = document.querySelector('#hamburger-toggle');

const t = (str) => (window.I18N && window.I18N[str]) || str;

window.addEventListener('scroll', () => {
  if (menu.checked) {
    menu.checked = false;
  }
});
window.addEventListener('scroll', () => {
  if (window.scrollY > 0 && window.scrollY > window.prevScrollY) {
    header.classList.toggle('translate-up', true);
    header.classList.toggle('translate-reset', false);
  } else {
    header.classList.toggle('translate-up', false);
    header.classList.toggle('translate-reset', true);
  }
  window.prevScrollY = window.scrollY;
});

const countryName = window.LANG === 'fr' ? 'FRNAME' : window.LANG === 'ar' ? 'ARNAME' : window.LANG === 'pt' ? 'PTNAME' : 'NAME';

const globeEl = document.getElementById('globeViz');
if (globeEl) {
  fetch(window.GEOJSON_URL)
    .then((response) => response.json())
    .then((countries) => {

      // Filtragem
      const allFeatures = countries.features;
      let filteredFeatures = allFeatures;

      if (pathParts.includes('countries')) {
        filteredFeatures = allFeatures.filter(f =>
          cleanName(f.properties[countryName]) === countrySlug
        );
      }

      function resizeGlobe() {
        const { width, height } = globeEl.getBoundingClientRect();
        const h = height>width ? width : height;
        world.width(width).height(h);
      }

      const world = new Globe(globeEl, { 
        rendererConfig: { alpha: true, antialias: true },
        animateIn: false,
        globeRadius: 200,
      })
        .pointOfView({ lat: 5, lng: 20, altitude: 1.6 }, 0)
        .globeImageUrl(window.EARTH_IMG_URL)
        .bumpImageUrl(window.TOPOLOGY_IMG_URL)
        .backgroundColor('rgba(0, 0, 0, 0)')
        .lineHoverPrecision(0)
        .polygonsData(filteredFeatures)
        .polygonAltitude(0.02)
        .polygonCapColor(() => 'rgba(0, 0, 0, 0.16)')
        .polygonSideColor(() => 'rgba(0, 0, 0, 0.32)')
        .polygonStrokeColor(() => '#ffffff')
        .onPolygonHover((hoverD) =>
          world
            .polygonAltitude((d) => (d === hoverD ? 0.04 : 0.02))
            .polygonCapColor((d) =>
              d === hoverD ? 'rgba(0, 0, 0, 0.32)' : 'rgba(0, 0, 0, 0.16)',
            ),
        )
        .onPolygonClick((clickD) =>
          window.location.href = window.BASE +"/countries/"+ cleanName(clickD.properties[countryName]),
        )
        .polygonsTransitionDuration(300)
        .htmlElementsData(filteredFeatures)
        .htmlElement((d) => {
          const el = document.createElement('div');
          el.className = 'marker';
          el.innerHTML = marker(d);
          return el;
        })
        .htmlLat((d) => getCentroid(d).lat)
        .htmlLng((d) => getCentroid(d).lng);

      // Controls
      world.controls().autoRotate = false;
      world.controls().autoRotateSpeed = 0;
      world.controls().enableZoom = false;

      // Add clouds sphere
      const CLOUDS_ALT = 0.01;
      const CLOUDS_ROTATION_SPEED = -0.0015;

      new THREE.TextureLoader().load(window.CLOUDS_IMG_URL, (cloudsTexture) => {
        const clouds = new THREE.Mesh(
          new THREE.SphereGeometry(
            world.getGlobeRadius() * (1 + CLOUDS_ALT),
            75,
            75,
          ),
          new THREE.MeshPhongMaterial({ map: cloudsTexture, transparent: true }),
        );
        world.scene().add(clouds);

        (function rotateClouds() {
          clouds.rotation.y += (CLOUDS_ROTATION_SPEED * Math.PI) / 180;
          requestAnimationFrame(rotateClouds);
        })();
      });

      // Luz ambiente mais forte (ilumina tudo de forma difusa)
      const ambientLight = new THREE.AmbientLight(0xffffff, 0.4);

      // Luz direcional potente vinda da direita
      const directionalLight = new THREE.DirectionalLight(0xffffff, 5);
      directionalLight.position.set(200, 150, 100); // vindo da direita e um pouco de cima

      // Luz spot direcionada pra África
      const spotLight = new THREE.SpotLight(0xffffff, 4.5);
      spotLight.position.set(0, 100, 200); // acima do globo
      spotLight.target.position.set(10, 0, 30); // mira na África
      spotLight.angle = Math.PI / 8;
      spotLight.penumbra = 0.5;
      spotLight.decay = 1;
      spotLight.distance = 800;

      world.scene().add(spotLight.target);

      // Aplica todas as luzes
      world.lights([ambientLight, directionalLight, spotLight]);

      resizeGlobe();
      window.addEventListener('resize', resizeGlobe);
    });

  function getCentroid(feature) {
    const type = feature.geometry.type;
    let coords = feature.geometry.coordinates;

    if (type === 'Polygon') {
      coords = coords[0]; // pega o anel exterior
    } else if (type === 'MultiPolygon') {
      coords = coords[0][0]; // pega o primeiro anel exterior do primeiro polígono
    }

    let area = 0,
      x = 0,
      y = 0;

    for (let i = 0, len = coords.length, j = len - 1; i < len; j = i++) {
      const [x0, y0] = coords[i];
      const [x1, y1] = coords[j];
      const f = x0 * y1 - x1 * y0;
      area += f;
      x += (x0 + x1) * f;
      y += (y0 + y1) * f;
    }

    area *= 3;
    return { lng: x / area, lat: y / area };
  }

  const marker = (d) => {
    if (pathParts.includes('countries')) {
      return `<div class="pin"></div>`;
    }else{
      return `<div class="pin"></div><p>${d.properties[countryName]}</p>`;
    }
  };
}

// AJAX Load 
  function changePage(url){
      preloader.classList.remove('out');
      body.style.overflow = 'hidden';

      if(!generalApp.timerPage){
          generalApp.timerPage = setTimeout(function(){
              window.history.pushState("", "", url);
              let http = new XMLHttpRequest();
              http.open('GET', addParam(url,"spajax=true"), true);
              http.onreadystatechange = function() {
                  if(http.readyState == 4 && http.status == 200) {
                      if(mainContent.outerHTML) {
                          mainContent.outerHTML=http.responseText;
                      }else{
                          var tmpObj=document.createElement("div");
                          tmpObj.innerHTML='<!--THIS DATA SHOULD BE REPLACED-->';
                          ObjParent=mainContent.parentNode;
                          ObjParent.replaceChild(tmpObj,mainContent);
                          ObjParent.innerHTML=ObjParent.innerHTML.replace('<div><!--THIS DATA SHOULD BE REPLACED--></div>',http.responseText);
                      }
                      setTimeout(function(){
                          var images = mainContent.getElementsByTagName("img");
                          var loaded = images.length;
                          for (var i = 0; i < images.length; i++) {
                              if (images[i].complete){
                                  loaded--;
                              }else{
                                  images[i].addEventListener("load", function() {
                                      loaded--;
                                      if (loaded == 0){
                                          start();
                                      }
                                  });
                              }
                          }
                          start();
                      },700);
                  }
                  document.getElementById('nav-main').checked = false;
                  body.style.overflow = 'auto';
                  window.scrollTo(0,0);
                  clearTimeout(generalApp.timerPage);
                  generalApp.timerPage = false;
              }
              http.send();
          },700);
      }
  }
  function loadContent(btn) {
  const container = document.getElementById('loadContainer');
  const form = document.getElementById('loadFilter');
  const moreWrap = document.getElementById('moreContainer');
  if (!container || !form || !moreWrap) return false;

  btn.classList.add('loading');
  const targetST = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

  const http = new XMLHttpRequest();
  const formData = serialize(form);

  // offset = quantos cards já existem dentro do grid
  const currentCount = container.children.length;

  http.open('GET', addParam(noParam(form.action), formData + "&contentajax=true&offset=" + currentCount), true);
  http.onreadystatechange = function() {
    if (http.readyState === 4) {
      if (http.status === 200 && http.responseText) {
        const tmp = document.createElement('div');
        tmp.innerHTML = http.responseText;

        const g = tmp.querySelector('#ajax-grid');
        const m = tmp.querySelector('#ajax-more');

        if (g) {
          container.insertAdjacentHTML('beforeend', g.innerHTML);
        }
        moreWrap.innerHTML = m ? m.innerHTML : '';
      }
      window.scrollTo(0, targetST);
    }
  };
  http.send();
}

  function changeContent(form) {
  const container = document.getElementById('loadContainer');
  const highlight = document.getElementById('highlightContainer');
  const moreWrap  = document.getElementById('moreContainer');
  if (!container || !highlight || !moreWrap) return false;

  container.classList.add('loading');
  form.classList.add('loading');

  const http = new XMLHttpRequest();
  const formData = serialize(form);

  window.history.pushState("", "", addParam(noParam(form.action), formData));

  http.open('GET', addParam(noParam(form.action), formData + "&contentajax=true&include_highlight=1&offset=0"), true);
  http.onreadystatechange = function() {
    if (http.readyState === 4) {
      if (http.status === 200 && http.responseText) {
        const tmp = document.createElement('div');
        tmp.innerHTML = http.responseText;

        const h = tmp.querySelector('#ajax-highlight');
        const g = tmp.querySelector('#ajax-grid');
        const m = tmp.querySelector('#ajax-more');

        highlight.innerHTML = h ? h.innerHTML : '<p class="text-white/80">'+ t('No results found') + '.</p>';
        container.innerHTML = g ? g.innerHTML : '';
        moreWrap.innerHTML  = m ? m.innerHTML : '';
      } else {
        highlight.innerHTML = '<p class="text-white/80">'+ t('No results found') + '.</p>';
        container.innerHTML = '';
        moreWrap.innerHTML  = '';
      }
      container.classList.remove('loading');
      form.classList.remove('loading');
    }
  };
  http.send();
}


  function addParam(url, param) {
      url += (url.split('?')[1] ? '&' : '?') + param;
      return url;
  }
  function noParam(url, param) {
      return url.split('?')[0];
  }
  function serialize(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
          if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;
          if (field.type === 'select-multiple') {
              Array.prototype.slice.call(field.options).forEach(function(option) {
                  if (!option.selected) return;
                  arr.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(option.value));
              });
              return;
          }
          if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;
          arr.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
      });
      return arr.join('&');
  }

  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('loadFilter');
    const loadMore = document.querySelectorAll('loadMore');
    if(loadMore){
      loadMore.forEach(btn => {
        btn.addEventListener('click', function (e) {
          loadContent(e.target);
        });
      });
    }
    if (form){
      form.addEventListener('change', function (e) {
      if (e.target.matches('select, input[type="radio"], input[type="checkbox"]')) {
        changeContent(form);
      }
    });}
  });


// More Resources
  function revealResourceItems(listEl) {
    if (!listEl) return;
    listEl.querySelectorAll('.resources-item.hidden').forEach(el => {
      el.classList.remove('hidden');
    });
  }

  // delegação de clique
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.js-more-resources');
    if (!btn) return;

    const targetId = btn.getAttribute('data-target');
    const list = document.getElementById(targetId);
    if (!list) return;

    revealResourceItems(list);
    btn.setAttribute('aria-expanded', 'true');
    btn.remove();
  });


// Parallax
  ;(() => {
    // ==== Guardas de ambiente ====
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (reduce || isTouch) return;

    // ==== Utils: origem do background ====
    const KW = { left: '0%', top: '0%', center: '50%', right: '100%', bottom: '100%' };

    function normalizeBase(val) {
      if (!val) return '50%';
      val = String(val).split(',')[0].trim(); // pega só o 1º se houver múltiplos backgrounds
      if (KW[val] != null) return KW[val];    // keywords -> %
      // aceita % ou px já computados
      if (/%$/.test(val) || /px$/.test(val)) return val;
      return '50%'; // fallback seguro
    }

    function getOrigin(el) {
      // 1) data-* explícito (prioritário)
      let ox = el.dataset.originX || el.dataset.origin || '';
      let oy = el.dataset.originY || el.dataset.origin || '';
      if (!el.dataset.originX && el.dataset.origin) {
        const parts = el.dataset.origin.trim().split(/\s+/);
        [ox, oy] = [parts[0] || '50%', parts[1] || '50%'];
      }

      // 2) CSS computado, se necessário
      if (!ox || !oy) {
        const cs = getComputedStyle(el);
        ox ||= cs.backgroundPositionX;
        oy ||= cs.backgroundPositionY;
      }

      return { ox: normalizeBase(ox), oy: normalizeBase(oy) };
    }

    // ==== Coleta inicial dos alvos ====
    let nodes = Array.from(document.querySelectorAll('[data-parallax]'));
    if (!nodes.length) return;

    const conf = new Map();     // { intensity }
    const origins = new Map();  // { ox, oy }
    nodes.forEach(el => {
      const intensity = parseFloat(el.getAttribute('data-intensity')) || 30; // px máx por eixo
      conf.set(el, { intensity });
      const { ox, oy } = getOrigin(el);
      origins.set(el, { ox, oy });

      // baseline visual, sem sobrescrever configs existentes
      el.style.backgroundPosition ||= `${ox} ${oy}`;
      el.style.backgroundRepeat   ||= 'no-repeat';
      // el.style.backgroundSize   ||= 'cover'; // opcional
    });

    // ==== Gestão de elementos ativos (no viewport) ====
    const active = new Set();

    // Estado global do mouse (normalizado -1..1 da viewport)
    let targetX = 0, targetY = 0, curX = 0, curY = 0, raf = null;

    function startTickIfNeeded() {
      if (!raf && active.size > 0) raf = requestAnimationFrame(tick);
    }

    function onPointerMove(e) {
      const vw = Math.max(window.innerWidth, 1);
      const vh = Math.max(window.innerHeight, 1);
      targetX = ((e.clientX / vw) - 0.5) * 2; // -1..1
      targetY = ((e.clientY / vh) - 0.5) * 2; // -1..1
      startTickIfNeeded();
    }

    function tick() {
      // easing suave
      curX += (targetX - curX) * 0.08;
      curY += (targetY - curY) * 0.08;

      active.forEach(el => {
        const { intensity } = conf.get(el) || { intensity: 30 };
        const { ox, oy } = origins.get(el) || { ox: '50%', oy: '50%' };
        const dx = (-curX * intensity).toFixed(2);
        const dy = (-curY * intensity).toFixed(2);

        // Mantém a origem (ex.: right/bottom) e desloca ao redor dela
        // Suporta bases em % ou px: calc(XX% + 10px) ou calc(20px + 10px)
        el.style.backgroundPosition = `calc(${ox} + ${dx}px) calc(${oy} + ${dy}px)`;
      });

      if (
        active.size > 0 &&
        (Math.abs(targetX - curX) > 0.001 || Math.abs(targetY - curY) > 0.001)
      ) {
        raf = requestAnimationFrame(tick);
      } else {
        raf = null;
      }
    }

    function resetToCenter() {
      targetX = 0; targetY = 0;
      startTickIfNeeded();
    }
    document.addEventListener('mouseleave', resetToCenter);
    window.addEventListener('blur', resetToCenter);

    // ==== IntersectionObserver: liga/desliga por visibilidade ====
    let io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver((entries) => {
        entries.forEach(({ isIntersecting, target }) => {
          if (isIntersecting) {
            active.add(target);
            startTickIfNeeded();
          } else {
            active.delete(target);
            // opcional: recentralizar quando sai da tela (mantendo a origem)
            const { ox, oy } = origins.get(target) || { ox: '50%', oy: '50%' };
            target.style.backgroundPosition = `${ox} ${oy}`;
          }
        });
      }, {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: 0 // qualquer pixel visível já ativa
      });

      nodes.forEach(el => io.observe(el));
    } else {
      // fallback sem IO
      nodes.forEach(el => active.add(el));
    }

    // ==== Listener global de ponteiro ====
    window.addEventListener('pointermove', onPointerMove, { passive: true });

    // ==== MutationObserver: elementos adicionados/removidos/atributos atualizados ====
    const mo = new MutationObserver((mutations) => {
      // Recoleta para simplificar a sincronização
      const fresh = Array.from(document.querySelectorAll('[data-parallax]'));

      // Adições
      fresh.forEach(el => {
        if (!conf.has(el)) {
          const intensity = parseFloat(el.getAttribute('data-intensity')) || 30;
          conf.set(el, { intensity });

          const { ox, oy } = getOrigin(el);
          origins.set(el, { ox, oy });

          el.style.backgroundPosition ||= `${ox} ${oy}`;
          el.style.backgroundRepeat   ||= 'no-repeat';

          if (io) io.observe(el); else active.add(el);
        }
      });

      // Remoções
      conf.forEach((_, el) => {
        if (!fresh.includes(el)) {
          conf.delete(el);
          origins.delete(el);
          active.delete(el);
          if (io) io.unobserve(el);
        }
      });

      // Atualizações de atributos (intensidade/origem)
      mutations.forEach(m => {
        const el = m.target;
        if (!(el instanceof Element)) return;
        if (!el.matches?.('[data-parallax]')) return;

        if (m.type === 'attributes') {
          if (m.attributeName === 'data-intensity') {
            const intensity = parseFloat(el.getAttribute('data-intensity')) || 30;
            conf.set(el, { intensity });
          }
          if (
            m.attributeName === 'data-origin' ||
            m.attributeName === 'data-origin-x' ||
            m.attributeName === 'data-origin-y'
          ) {
            const { ox, oy } = getOrigin(el);
            origins.set(el, { ox, oy });
            // recentraliza visualmente na nova origem
            el.style.backgroundPosition = `${ox} ${oy}`;
          }
        }
      });

      startTickIfNeeded();
    });

    mo.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-parallax', 'data-intensity', 'data-origin', 'data-origin-x', 'data-origin-y']
    });
  })();

  // Global variables
  window.loadContent   = loadContent;
  window.changeContent = changeContent;

    document.querySelectorAll('.splide-main-slider').forEach(function (el) {
      const counter = el.querySelector('.splide-counter');
      const currentEl = el.querySelector('.splide-counter__current');
      const totalEl = el.querySelector('.splide-counter__total');

      const splide = new Splide(el, {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        gap: '3rem',
        arrows: true,
        pagination: false,
        drag: true,
      });

      function updateCounter() {
        if (!counter || !currentEl || !totalEl) return;
        currentEl.textContent = String(splide.index + 1);
        totalEl.textContent = String(splide.length);
      }

      splide.on('mounted move', updateCounter);
      splide.mount();
    });
    
    document.querySelectorAll('.splide-secondary-slider').forEach(function (el) {
      new Splide(el, {
        type: 'slide',
        perPage: 2,
        perMove: 1,
        gap: '3rem',
        arrows: false,
        pagination: false,
        drag: true,

        breakpoints: {
          1024: {
            perPage: 1,
          },
        },
      }).mount();
    });
